import { useTranslation } from "next-i18next";

const SocialMediaContent = () => {
    const { t } = useTranslation(["blog"]);

    const socialMedia = [
        {
            id: 1,
            icon: "ri-instagram-line",
            link: "https://www.instagram.com/makdos.cloud/",
            name: "makdos.cloud"
        },
        {
            id: 2,
            icon: "ri-facebook-circle-line",
            link: "https://www.facebook.com/makdostech",
            name: "makdos"
        },
        {
            id: 3,
            icon: "ri-linkedin-line",
            link: "https://tr.linkedin.com/company/makdos",
            name: "makdos"
        }
    ]

    return (
        <div className="hidden p-6 bg-white rounded-md lg:block">
            <h5 className="pb-4 text-2xl font-semibold">{t("blog:socialMedia")}</h5>
            <p className="text-textGray">{t("blog:followSocialMedia")}</p>

            <div className="pt-5">
                {socialMedia.map((media, index) =>
                    <div key={index} className="flex items-center justify-between pb-6">
                        <div className="flex items-center justify-center space-x-2">
                            <i className={`text-2xl text-black ${media.icon}`}></i>
                            <a href={media.link} target="_blank" rel="noopener noreferrer" className="text-textGray">{media.name}</a>
                        </div>
                        <p className="text-textGray px-4 py-2.5 rounded-full border-2 border-buttonBg cursor-pointer"><a href={media.link} target="_blank">{t("blog:follow")}</a></p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SocialMediaContent